<template>
	<div class="text-center" :key="key">
		<h1 class="h1 font-weight-bold d-none d-lg-block">{{ $t('Járat igénylés') }}</h1>

    <!--<p class="font-weight-bold alert-content" v-if="routeId === '1570'">
      Tisztelt utasaink!
      <br />
      <br />
      Rendezvény miatt április 27-én, vasárnap a 157-es autóbusz 15:24-es Hűvösvölgyi indulásában csak Budaliget, Géza fejedelem útja végállomásig közlekedik. Kérjük, hogy ezen a napon a 15:24-es Hűvösvölgyi és a 15:46-os Solymár, Kerekhegyi indulásokra ne adjon le igényt.
    </p>-->

		<div class="step pb-5" id="step-1">
			<h3 class="step__title">
				<div>
					<span class="step__index">1</span>
				</div>
				<div>{{$t('Irány kiválasztása')}}</div>
			</h3>

			<div class="row" v-if="stopsDirection0.length || stopsDirection1.length">
				<div class="col-12 col-lg-6 py-1" v-if="stopsDirection0.length">
					<div
						class="step__direction"
						:class="{'step__direction--selected': demandRequestDTO.directionId === 0}"
						@click="directionToggle(0)"
					>
						<div class="row form-row align-items-center direction__header">
							<div class="col-auto">
								<button
									:disabled="step === 1? false : 'disabled'"
									class="direction__toggler text-0"
									:class="{'direction__toggler--toggled': demandRequestDTO.directionId === 0 && directionToggled }"
								>
									<inline-svg :src="require('@/assets/icons/caret-right.svg')"></inline-svg>
								</button>
							</div>
							<div class="col-auto">
								<div
                    class="direction__icon"
                    :style="{backgroundColor: routeColor(stopsDirection0[stopsDirection0.length-1].routeColor)}"
                >
									<RouteLogo
                      :routeId="stopsDirection0[stopsDirection0.length-1].routeId"
                      :color="routeTextColor(stopsDirection0[stopsDirection0.length-1].routeTextColor)"
                  />
								</div>
							</div>
							<div class="col">
                <div class="form-row align-items-center">
									<span class="col-auto">
                    <span
                        class="direction__routeName"
                        :style="{color: routeTextColor(stopsDirection0[stopsDirection0.length - 1].routeTextColor), backgroundColor: routeColor(stopsDirection0[stopsDirection0.length - 1].routeColor)}"
                    >
                      {{ stopsDirection0[stopsDirection0.length - 1].routeName }}</span>
                  </span>
									<span class="col-auto text-0">
										<inline-svg class="direction__arrow" :src="require('@/assets/icons/direction-right.svg')"></inline-svg>
									</span>
									<span class="col-auto">{{ stopsDirection0[stopsDirection0.length-1].stopName }}</span>
								</div>
							</div>
						</div>

						<div
							class="direction__content"
							v-show="demandRequestDTO.directionId === 0 && directionToggled"
						>
							<RouteStopSelector
								:fromStopIndex="fromStopIndex"
								:toStopIndex="toStopIndex"
								@selectStop="selectRouteStop"
								:stops="stopsDirection0"
							></RouteStopSelector>
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-6 py-1" v-if="stopsDirection1.length">
					<div
						class="step__direction"
						:class="{'step__direction--selected': demandRequestDTO.directionId === 1}"
						@click="directionToggle(1)"
					>
						<div class="row form-row align-items-center direction__header">
							<div class="col-auto">
								<button
									:disabled="step === 1? false : 'disabled'"
									class="direction__toggler text-0"
									:class="{'direction__toggler--toggled': demandRequestDTO.directionId === 1 && directionToggled }"
								>
									<inline-svg :src="require('@/assets/icons/caret-right.svg')"></inline-svg>
								</button>
							</div>
							<div class="col-auto">
								<div
                    class="direction__icon"
                    :style="{backgroundColor: routeColor(stopsDirection1[stopsDirection1.length-1].routeColor)}"
                >
									<RouteLogo
                      :routeId="stopsDirection1[stopsDirection1.length-1].routeId"
                      :color="routeTextColor(stopsDirection1[stopsDirection1.length-1].routeTextColor)"
                  />
								</div>
							</div>
							<div class="col">
								<div class="form-row align-items-center">
									<span class="col-auto color-blue font-weight-bold">
                    <span
                        class="direction__routeName"
                        :style="{color: routeTextColor(stopsDirection1[stopsDirection1.length - 1].routeTextColor), backgroundColor: routeColor(stopsDirection1[stopsDirection1.length - 1].routeColor)}"
                    >
                      {{stopsDirection1[stopsDirection1.length-1].routeName}}
                    </span>
                  </span>
									<span class="col-auto text-0">
										<inline-svg class="direction__arrow" :src="require('@/assets/icons/direction-right.svg')"></inline-svg>
									</span>
									<span class="col-auto">{{ stopsDirection1[stopsDirection1.length-1].stopName }}</span>
								</div>
							</div>
						</div>

						<div
							class="direction__content"
							v-show="demandRequestDTO.directionId === 1 && directionToggled"
						>
							<RouteStopSelector
								:fromStopIndex="fromStopIndex"
								:toStopIndex="toStopIndex"
								@selectStop="selectRouteStop"
								:stops="stopsDirection1"
							></RouteStopSelector>
						</div>
					</div>
				</div>
			</div>

			<div class="text-left pt-4" v-if="step === 1">
				<button
					@click="nextStep()"
					:disabled="demandRequestDTO.directionId!==null?false:'disabled'"
					class="button w-lg-auto"
					style="min-width: 160px; width: 100%;"
				>{{$t('Tovább')}}</button>
			</div>
		</div>

		<div class="step pb-5" id="step-2" v-show="step >= 2">
			<h3 class="step__title">
				<div>
					<span class="step__index">2</span>
				</div>
				<div>{{$t('Megállók kiválasztása')}}</div>
			</h3>

			<div class="row">
				<div class="col-12 col-lg-6">
					<div class="form-group form-group--with-icon form-group--dropdown">
						<input
							v-input-class
							type="text"
							readonly
							class="input bg-white input--small"
							:placeholder="$t('Honnan')"
							@click="directionDropdownToggled = 'from'"
							:value="fromStopIndex!==null?selectedStops[fromStopIndex].stopName:''"
						/>
						<span class="input__icon">
							<img src="@/assets/icons/from-a.svg" :alt="$t('Honnan')" />
						</span>
						<span style="height:40px; line-height:40px; right: 20px; top: 0; position: absolute; width:40px" v-if="fromStopIndex!==null?selectedStops[fromStopIndex].specialSign == 'a':''" class="input__icon2">
                                                        <inline-svg class="demand-driven-icon" style="width:20px; height: 20px;" :src="require('@/assets/icons/a-pikto.svg')"></inline-svg>
                                                </span>
						<span class="disable-pointer input__dropdown-icon input__dropdown-icon--small">
                                                        <inline-svg :src="require('@/assets/icons/caret-right.svg')"></inline-svg>
						</span>

						<RouteStopSelectorDropdown
							v-show="directionDropdownToggled === 'from'"
							:stopType="'from'"
							:fromStopIndex="fromStopIndex"
							:toStopIndex="toStopIndex"
							@closeDropdown="closeDropdown('from')"
							@selectStop="selectRouteStop"
							:stops="selectedStops"
						></RouteStopSelectorDropdown>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12 col-lg-6">
					<div class="form-group form-group--with-icon">
						<input
							v-input-class
							type="text"
							class="input bg-white input--small"
							readonly
							:placeholder="$t('Hova')"
							@click="directionDropdownToggled = 'to'"
							:value="toStopIndex!==null?selectedStops[toStopIndex].stopName:''"
						/>
						<span class="input__icon">
							<img src="@/assets/icons/to-b.svg" :alt="$t('Hova')" />
						</span>
						<span style="height:40px; line-height:40px; right: 20px; top: 0; position: absolute; width:40px" v-if="toStopIndex!==null?selectedStops[toStopIndex].specialSign == 'a':''" class="input__icon2">
                                                        <inline-svg class="demand-driven-icon" style="width:20px; height: 20px;" :src="require('@/assets/icons/a-pikto.svg')"></inline-svg>
                                                </span>
						<span class="disable-pointer input__dropdown-icon input__dropdown-icon--small">
							<inline-svg :src="require('@/assets/icons/caret-right.svg')"></inline-svg>
						</span>

						<RouteStopSelectorDropdown
							v-show="directionDropdownToggled === 'to'"
							:stopType="'to'"
							:fromStopIndex="fromStopIndex"
							:toStopIndex="toStopIndex"
							@closeDropdown="closeDropdown('from')"
							@selectStop="selectRouteStop"
							:stops="selectedStops"
						></RouteStopSelectorDropdown>
					</div>
				</div>
			</div>

			<div class="text-left pt-4" v-if="step === 2">
				<button
					@click="nextStep()"
					:disabled="(demandRequestDTO.fromStop && demandRequestDTO.toStop)?false:'disabled'"
					class="button w-lg-auto"
					style="min-width: 160px; width: 100%;"
				>{{$t('Tovább')}}</button>
			</div>
		</div>

		<div class="step" id="step-3" v-show="step >= 3">
			<h3 class="step__title">
				<div>
					<span class="step__index">3</span>
				</div>
				<div>{{$t('Indulási időpont, utasok')}}</div>
			</h3>
            <p class="font-italic" style="font-size:12px">{{$t('Egy foglalásban maximum 6 fő foglalása lehetséges.')}}</p>            
			<p class="font-italic" style="font-size:12px">
			<inline-svg class="demand-driven-icon" style="width:20px; height: 20px;" :src="require('@/assets/icons/a-pikto.svg')"></inline-svg>
			<span v-html=specialSignMessage></span>
			</p>
            <p class="color-red" v-if="noTimesForToday">{{$t('A mai napra nincs elérhető időpont, kérjük válasszon másik napot!')}}</p>

			<div class="row">
				<div class="col-12 col-lg-6">
					<div class="form-row">
						<div class="col">
							<div class="form-group">
								<label for="travelDate" class="color-grey3 text-smaller d-block mb-0">{{$t('Év/Hónap/Nap')}}</label>
								<datetime
									type="date"
									:min-datetime="new Date().toISOString()"
									format="y-LL-dd"
									input-id="travelDate"
									input-class="input bg-white input--small"
									v-model="demandRequestDTO.travelDate"
                                    :phrases="{ok: 'OK', cancel: $t('Mégse')}"
								></datetime>
							</div>
						</div>
						<div class="col">
							<div class="form-group">
								<label
									for="arrivalTime"
									class="color-grey3 text-smaller d-block mb-0"
								>{{$t('Indulás időpontja')}}</label>
                                <v-select v-model="demandRequestDTO.arrivalTime" :clearable="false" :searchable="false" :placeholder="$t('Időpont')" :reduce="time => time.arrivalTime" :getOptionLabel="arrivalTimeLabel" :options="times">
                                    <slot name="no-options">{{$t('Nincs elérhető időpont')}}</slot>
                                    <template #no-options>
                                        {{$t('Nincs elérhető időpont')}}
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <span>{{ option.arrivalTime | arrivalTime }}</span>
										<inline-svg class="demand-driven-icon" v-if="option.specialSign" style="width:20px; height: 20px;" :src="require('@/assets/icons/a-pikto.svg')"></inline-svg>
                                        <inline-svg class="demand-driven-icon" v-if="option.demandDriven" :src="require('@/assets/icons/is-demand-driven.svg')"></inline-svg>
                                    </template>

                                    <template #selected-option-container="{ option }">
                                        <div class="vs__selected">{{ option.arrivalTime | arrivalTime }}
											<inline-svg class="demand-driven-icon" v-if="option.specialSign" style="width:20px; height: 20px;" :src="require('@/assets/icons/a-pikto.svg')"></inline-svg>
											<inline-svg class="demand-driven-icon" v-if="option.demandDriven" :src="require('@/assets/icons/is-demand-driven.svg')"></inline-svg>                                            
										</div>
                                    </template>

                                    <template #open-indicator="{ attributes }">
                                        <span v-bind="attributes" class="pr-1"><inline-svg style="transform:rotate(90deg)" :src="require('@/assets/icons/caret-right.svg')"></inline-svg></span>
                                    </template>
                                </v-select>

							</div>
						</div>

						<div class="col-auto">
							<div class="form-group">
								<label
									for="numberOfPassengers"
									class="color-grey3 text-smaller d-block mb-0"
								>{{$t('Utasok (fő)')}}</label>
								<input
									v-model.number="demandRequestDTO.numberOfPassengers"
									v-input-class
									type="number"
									:min="1"
									:max="6"
                                    style="width: 70px"
									id="numberOfPassengers"
									class="input bg-white input--small"
									:placeholder="$t('Utasok (fő)')"
								/>
							</div>
						</div>
					</div>

					<div class="form-group form-group--checkbox">
						<div class="checkbox">
							<input
								v-model="demandRequestDTO.wheelchair"
								type="checkbox"
								id="wheelchair"
								class="checkbox__input"
							/>
							<label for="wheelchair" class="checkbox__label"></label>
						</div>

						<label for="wheelchair">
							<span class="font-weight-bold">{{ $t('Kerekesszékkel utazom') }}</span>
							<span>{{$t('(Tájékoztatjuk, hogy a járat méretéből adódoan 1db kerekesszéket tudunk elszállítani)')}}</span>
						</label>
					</div>

					<div class="form-group form-group--checkbox">
						<div class="checkbox">
							<input
								v-model="demandRequestDTO.babyCarriage"
								type="checkbox"
								id="babyCarriage"
								class="checkbox__input"
							/>
							<label for="babyCarriage" class="checkbox__label"></label>
						</div>

						<label for="babyCarriage">
							<span class="font-weight-bold">{{ $t('Babakocsival utazom') }}</span>
							<span>{{$t('(Tájékoztatjuk, hogy a járat méretéből adódoan 1db babakocsit tudunk elszállítani)')}}</span>
						</label>
					</div>

					<div class="form-row">
						<div class="col-6 py-1">
							<router-link tag="button" :to="{name: 'demand-request'}" class="button w-100">{{$t('Mégse')}}</router-link>
						</div>
						<div class="col-6 py-1">
							<button
								:disabled="formValid?false:'disabled'"
								@click="submitRequest()"
								class="button button--blue w-100"
							>{{$t('Igénylés leadása')}}</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Loader v-if="loaderIds.length" :loaderText="loaderMessage"></Loader>
	</div>
</template>

<script>
import { DateTime } from 'luxon';
import {removeNullKeys, routeColor, routeTextColor} from "@/utils"
import {
	getStopsOfRouteUsingGET,
	getStopTimesOfRouteByDateUsingGET,
	addDemandRequestUsingPOST,
	getAccountUsingGET,
} from "@/api";
import RouteStopSelector from "@/components/RouteStopSelector";
import RouteStopSelectorDropdown from "@/components/RouteStopSelectorDropdown";
import RouteLogo from "@/components/RouteLogo";
import Loader from "@/components/Loader";
import vSelect from 'vue-select';

import 'vue-select/dist/vue-select.css';

export default {
	name: "DemandRequestProcess",
	props: ["routeId"],
	components: {
		RouteStopSelector,
		RouteStopSelectorDropdown,
		RouteLogo,
        Loader,
        'v-select': vSelect
	},
	data() {
		return {
            key: new Date().getTime() / 1000,
			stopsLoading: true,
			loaderMessage: this.$t("A megállók betöltése folyamatban..."),
			specialSignMessage: this.$t("a piktogrammal jelölt indulási időpontban a gépjármű nem végállomásig közlekedik. A részletekről keresse fel a https://bkk.hu/menetrendek/ oldalt."),
            loaderActive: true,
            loaderIds: [],
			step: 1,
			directionToggled: false,
			directionDropdownToggled: null,
			demandRequestDTO: {"arrivalTime": null,"babyCarriage": null,"directionId": null,"favorite": null,"fromStop": null,"id": null,"numberOfPassengers": null,"overflown": null,"route": null,"status": null,"toStop": null,"travelDate": null,"user": null,"wheelchair": null},
			fromStopIndex: null,
			toStopIndex: null,
			stopsDirection0: [],
			stopsDirection1: [],
            times: [],
            noTimesForToday: false
		};
	},
	computed: {
        isRouteDemandDriven: function() {
            let hasDemandDrivenStop = false;
            if(this.fromStopIndex === null || this.toStopIndex === null) return null;
            for(let i = this.fromStopIndex; i <= this.toStopIndex; i++) {
                if(this.selectedStops[i].isDemandDriven){
                    hasDemandDrivenStop = true;
                }
            }
            return hasDemandDrivenStop;
        },
		selectedStops: function () {
			if (this.demandRequestDTO.directionId === null) return [];

			switch (this.demandRequestDTO.directionId) {
				case 0:
					return this.stopsDirection0;
					break;
				case 1:
					return this.stopsDirection1;
					break;
				default:
					return [];
			}
		},
		formValid: function () {
			if (
				this.demandRequestDTO.directionId === null ||
				this.demandRequestDTO.fromStop === null ||
				this.demandRequestDTO.toStop === null ||
				!this.demandRequestDTO.travelDate ||
				!this.demandRequestDTO.arrivalTime ||
				!this.demandRequestDTO.numberOfPassengers
			) {
				return false;
			}
			return true;
		},
	},
	watch: {
		"demandRequestDTO.directionId": function (val, oldVal) {
            if(oldVal === null) return true;
			this.fromStopIndex = null;
			this.toStopIndex = null;
			this.demandRequestDTO.fromStop = null;
			this.demandRequestDTO.toStop = null;
		},
		"demandRequestDTO.travelDate": function (val) {
			if (this.step === 3) this.getTimes();
		},
		"demandRequestDTO.babyCarriage": function (val) {
			if (val) {
				this.demandRequestDTO.wheelchair = false;
			}
		},
		"demandRequestDTO.wheelchair": function (val) {
			if (val) {
				this.demandRequestDTO.babyCarriage = false;
			}
		},
		"demandRequestDTO.numberOfPassengers": function(newVal, oldVal) {
            if(newVal == "") return true;
			if(newVal > 6 || newVal < 1) {
				this.demandRequestDTO.numberOfPassengers = oldVal;
			}
		}
	},
	created() {
		if (typeof this.$route.query.directionId !== "undefined" && this.$route.query.directionId !== "") {
            this.demandRequestDTO.directionId = parseInt(this.$route.query.directionId) > 0 ? 1 : 0;
        }
			
		if (typeof this.$route.query.fromStop !== "undefined")
			this.demandRequestDTO.fromStop = this.$route.query.fromStop;
		if (typeof this.$route.query.toStop !== "undefined")
            this.demandRequestDTO.toStop = this.$route.query.toStop;

        if(this.demandRequestDTO.directionId !== null && (!this.demandRequestDTO.fromStop || !this.demandRequestDTO.toStop)) {
            this.directionToggled = true;
        }

		this.demandRequestDTO.route = this.routeId;
		this.demandRequestDTO.numberOfPassengers = 1;
        if (typeof this.$route.query.travelDate !== "undefined") {
            this.demandRequestDTO.travelDate = this.$route.query.travelDate + "T00:00:00.000Z";
        }
        else
		    this.demandRequestDTO.travelDate = new Date().toISOString();

		this.getStops();

		getAccountUsingGET().then((response) => {
			if (typeof response.data.useWheelchair !== "undefined") {
				this.demandRequestDTO.wheelchair = response.data.useWheelchair;
			}

			if (typeof response.data.id !== "undefined") {
				this.demandRequestDTO.user = response.data.id;
			}
		});
	},
	methods: {
    routeColor,
    routeTextColor,
        arrivalTimeLabel: function(option) {
            return option.arrivalTime? this.$options.filters.arrivalTime(option.arrivalTime):"";
        },
		closeDropdown: function (type) {
			this.directionDropdownToggled = null;
		},
		selectRouteStop: function (data) {
			if (
				typeof data.single !== "undefined" &&
				typeof data.singleType !== "undefined"
			) {
				switch (data.singleType) {
					case "from":
						if (data.index === this.selectedStops.length - 1)
							return;
						this.fromStopIndex = data.index;
						this.demandRequestDTO.fromStop = data.stop.stopId;
						if (
							this.toStopIndex !== null &&
							this.toStopIndex <= data.index
						) {
							this.toStopIndex = null;
						}
						break;
					case "to":
						if (data.index === 0) return;
						this.toStopIndex = data.index;
						this.demandRequestDTO.toStop = data.stop.stopId;
						if (
							this.fromStopIndex !== null &&
							this.fromStopIndex >= data.index
						) {
							this.fromStopIndex = null;
						}
						break;
                }
                if(this.step === 3) this.getTimes();
				return;
			}

			if (this.fromStopIndex === null) {
				this.fromStopIndex = data.index;
				this.demandRequestDTO.fromStop = data.stop.stopId;
				this.toStopIndex = null;
			} else {
				if (this.fromStopIndex >= data.index) {
					this.fromStopIndex = data.index;
					this.demandRequestDTO.fromStop = data.stop.stopId;
					this.toStopIndex = null;
				} else {
					if (this.toStopIndex === null) {
						this.toStopIndex = data.index;
						this.demandRequestDTO.toStop = data.stop.stopId;
					} else {
						this.fromStopIndex = data.index;
						this.demandRequestDTO.fromStop = data.stop.stopId;
						this.toStopIndex = null;
					}
				}
            }
		},
		directionToggle: function (val) {
			if (this.step !== 1) {
				this.step = 1;
			}
			if (
				this.demandRequestDTO.directionId === val &&
				this.directionToggled
			) {
				return (this.directionToggled = false);
			}
			this.demandRequestDTO.directionId = val;
			this.directionToggled = true;
		},
		nextStep: function () {
			this.step++;
            this.directionToggled = false;
            
            if(this.isRouteDemandDriven === false) {
                this.$swal({
                    title: this.$t("Járat igénylés"),
                    text: this.$t("Az Ön által kiválasztott útvonalon nincs szükség járat igénylésre, mert a járat menetrend szerint közlekedik!"),
                    imageUrl: window.swalInfo,
                });
            }

			if (this.step === 3) {
				this.getTimes();
			}
		},
		getStops: function () {
            this.loaderIds.push("getStopsOfRouteUsingGET0");
			getStopsOfRouteUsingGET({ directionId: 0, routeId: this.routeId })
				.then((response) => {
					this.stopsDirection0 = response.data;
					this.loaderIds = this.loaderIds.filter(e => e !== "getStopsOfRouteUsingGET0");

					if (this.demandRequestDTO.directionId === 0) {
                        for (let i = 0; i < response.data.length; i++) {
                            if (typeof this.$route.query.fromStop !== "undefined") {  
								if (response.data[i].stopId == this.$route.query.fromStop.toString()) {
									this.fromStopIndex = i;
                                }
                            }

                            if (typeof this.$route.query.toStop !== "undefined") {
                                if (response.data[i].stopId == this.$route.query.toStop.toString()) {
									this.toStopIndex = i;
                                }
                            }
						}
                        
                        if(this.fromStopIndex !== null && this.toStopIndex !== null) {
                            this.step = 3;
                            this.getTimes();
                        }
					}
				})
				.catch((err) => {
                    this.$swal({
						title: this.$t("Megállók"),
						text: this.$t("A megállók betöltése közben hiba történt. Hiba oka:") + " " + err.errorMessage,
						imageUrl: window.swalError,
					});
					this.loaderIds = this.loaderIds.filter(e => e !== "getStopsOfRouteUsingGET0");
				});
            this.loaderIds.push("getStopsOfRouteUsingGET1");
			getStopsOfRouteUsingGET({ directionId: 1, routeId: this.routeId })
				.then((response) => {
					this.stopsDirection1 = response.data;

					this.loaderIds = this.loaderIds.filter(e => e !== "getStopsOfRouteUsingGET1");

					if (this.demandRequestDTO.directionId === 1) {
						for (let i = 0; i < response.data.length; i++) {
                            if (typeof this.$route.query.fromStop !== "undefined") {   
								if (response.data[i].stopId == this.$route.query.fromStop.toString()) {
									this.fromStopIndex = i;
                                }
                            }

                            if (typeof this.$route.query.toStop !== "undefined") {
                                if (response.data[i].stopId == this.$route.query.toStop.toString()) {
									this.toStopIndex = i;
                                }
                            }
						}
                        
                        if(this.fromStopIndex !== null && this.toStopIndex !== null) {
                            this.step = 3;
                            this.getTimes();
                        }
					}
				})
				.catch((err) => {
                    this.$swal({
						title: this.$t("Megállók"),
						text: this.$t("A megállók betöltése közben hiba történt. Hiba oka:") + " " + err.errorMessage,
						imageUrl: window.swalError,
					});
					this.loaderIds = this.loaderIds.filter(e => e !== "getStopsOfRouteUsingGET1");
				});
		},
		getTimes: function () {
			if (
				this.demandRequestDTO.directionId === null ||
				!this.demandRequestDTO.travelDate
			)
				return false;

			this.loaderMessage = this.$t("Járat indulási időpontok betöltése folyamatban...");
            this.loaderIds.push("getTimes");
            
            let travelDate = this.$options.filters.formatDate(this.demandRequestDTO.travelDate);

			getStopTimesOfRouteByDateUsingGET({
				directionId: this.demandRequestDTO.directionId,
				routeId: this.routeId,
                stopId: this.demandRequestDTO.fromStop,
				date: travelDate,
			})
				.then((response) => {
                    this.noTimesForToday = false;
					if (response.status === 200) {
						if (!response.data.length) {
                            this.times = [];
                            this.demandRequestDTO.arrivalTime = null;
							let msg = this.$t("A megadott dátumra nincs elérhető foglalási időpont!");

							if (
								travelDate ===
								DateTime.local().toISODate()
							) {
                                this.noTimesForToday = true;
							} else {
                                this.$swal({
                                    title: this.$t("Járat igénylés"),
                                    text: msg,
                                    imageUrl: window.swalError,
                                });
                            }
						} else {
							this.times = response.data;

                            if (typeof this.$route.query.arrivalTime !== "undefined") {
                                let findTime = this.times.find(e => e.arrivalTime === this.$route.query.arrivalTime);
                                if(findTime) {
                                    this.demandRequestDTO.arrivalTime = findTime.arrivalTime;
                                } else {
                                    this.demandRequestDTO.arrivalTime = response.data[0].arrivalTime;
                                }
                            } else {
                                this.demandRequestDTO.arrivalTime = response.data[0].arrivalTime;
                            }
							
						}
					}
					this.loaderIds = this.loaderIds.filter(e => e !== "getTimes");
				})
				.catch((err) => {
                    this.loaderIds = this.loaderIds.filter(e => e !== "getTimes");
                    this.$swal({
						title: this.$t("Indulási idő"),
						text: this.$t("Az indulási idők betöltése közben hiba történt. Hiba oka:") + " " + err.errorMessage,
						imageUrl: window.swalError,
					});
				});
		},
		submitRequest: function (confirmed = false) {
			let selectedTime = this.times.find(
				(e) => e.arrivalTime === this.demandRequestDTO.arrivalTime
            );

            // for backend misbehave
            let hasDemandDrivenStop = false;
            for(let i = this.fromStopIndex; i <= this.toStopIndex; i++) {
                if(this.selectedStops[i].isDemandDriven){
                    hasDemandDrivenStop = true;
                }
            }

//.replace("<a>", "<a href='https://bkk.hu/menetrendek' target=blank>")

			if (!confirmed && selectedTime.specialSign == 'a') {
				return this.$swal({
					title: this.$t("Járat igénylés"),
                    html: this.$t("A kiválasztott indulási időpontban a gépjármű nem végállomásig közlekedik. A részletekről keresse fel a https://bkk.hu/menetrendek/ oldalt."),
                    showCancelButton: true,
                    confirmButtonText: this.$t("Rendben"),
                    cancelButtonText: this.$t("Mégsem"),
                    imageUrl: window.swalInfo,
					customClass: {
						confirmButton: 'button button--blue button--swal',
						cancelButton: 'button button--swal',
						title: 'text-biggest font-weight-bold',
						actions: 'swal2-confirm-actions'
					}
				}).then((result) => {
					if (result.isConfirmed) {
						this.submitRequest(true);
					}
				});
			}
            
            if (
                (selectedTime && !selectedTime.demandDriven) ||
                //( (selectedTime && selectedTime.demandDriven) && (!this.selectedStops[this.fromStopIndex].isDemandDriven && !this.selectedStops[this.toStopIndex].isDemandDriven))
                ( (selectedTime && selectedTime.demandDriven) && !hasDemandDrivenStop)
            ) {
                    return this.$swal({
                        title: this.$t("Járat igénylés"),
                        text: this.$t("Az Ön által igényelt időpontban a kiválasztott útvonalon nincs szükség járat igénylésre, mert a járat menetrend szerint közlekedik. Igénylését emiatt rendszerünk nem rögzíti!"),
                        imageUrl: window.swalInfo,
                    });
            }

			let demandRequestDto = JSON.parse(JSON.stringify(this.demandRequestDTO));
			demandRequestDto.travelDate = this.$options.filters.formatDate(this.demandRequestDTO.travelDate);
			
			this.loaderMessage = this.$t('Igénylés leadása folyamatban...');
            this.loaderIds.push("submitRequest");

			addDemandRequestUsingPOST({
				demandRequestDto: removeNullKeys(demandRequestDto),
			}).then((response) => {
            this.loaderIds = this.loaderIds.filter(e => e !== "submitRequest");
				if (response.status === 200) {

                    let responseText = response.data.overflown? this.$t("Köszönjük, igénylését rögzítettük. Az igényelt időpontban fáradjon az igényelt megállóba. A jármű kapacitásából adódan elképzelhető, hogy kollégáink keresik Önt a megadott telefonos elérhetőségen.") : this.$t("Járat igénylése sikeres volt!");

					this.$swal({
						title: this.$t("Sikeres igénylés"),
						text: responseText,
						imageUrl: window.swalSuccess,
					}).then(() => {
						this.$router.push({ name: "requests" });
					});
				}
			}).catch(err => {
				this.loaderIds = this.loaderIds.filter(e => e !== "submitRequest");
				this.$swal({
						title: this.$t("Hiba történt"),
						text: this.$t("Járat igénylése közben hiba történt. Hiba oka:") + " " + err.errorMessage,
						imageUrl: window.swalError,
					});
			});
		}
	}
};
</script>
<style lang="scss" src="@/assets/scss/vue-select-custom.scss"></style>
<style lang="scss" src="@/assets/scss/demand-request-process.scss" scoped></style>